module.exports = __webpack_public_path__ + "static/img/huishouzhan.fbd1335b.png";